var render = function render(){var _vm=this,_c=_vm._self._c;return _c('config-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],attrs:{"label":_vm.label}},[_c('el-slider',_vm._b({attrs:{"show-input":""},model:{value:(_vm.mValue),callback:function ($$v) {_vm.mValue=$$v},expression:"mValue"}},'el-slider',_vm.mOptions,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }